:host 
  display: block
  width: fit-content
  height: fit-content

a
  width: 100%
  height: 100%

img 
  display: block

img.standard
  width: 100%
  height: 100%

img.ratio
  max-height: 100%
  max-width: 100%
